/**
 * Commodity Fixing Service (KAN-300 Phase 4)
 * Frontend service for commodity fixing / expiry API calls
 */

import { apiClient, APIResponse } from './client';

// ========== Types ==========

export interface MaturedTradeGroup {
  fixingReference: string;
  label: string;
  maturityDate: string;
  tradeCount: number;
  settlementPrice: number | null;
  currency: string;
  available: boolean;
}

export interface MaturedTradesResponse {
  targetDate: string;
  groups: MaturedTradeGroup[];
  trades: Record<string, any>[];
  allAvailable: boolean;
  missingCount: number;
}

export interface FixingRunResult {
  targetDate: string;
  clientsProcessed: number;
  tradesScanned: number;
  tradesFixed: number;
  tradesSkipped: number;
  errors: Array<{ error?: string; tradeId?: string; entityId?: string }>;
}

// ========== Service ==========

class CommodityFixingService {
  /**
   * Get matured trades grouped by fixing reference, with price availability.
   */
  async getMaturedTrades(
    clientId: string,
    targetDate: string
  ): Promise<APIResponse<MaturedTradesResponse>> {
    return apiClient.get<MaturedTradesResponse>(
      `/api/v1/commodity-fixing/${clientId}/matured-trades?targetDate=${targetDate}`
    );
  }

  /**
   * Trigger commodity fixing for a specific client.
   */
  async runFixing(
    clientId: string,
    targetDate?: string
  ): Promise<APIResponse<FixingRunResult>> {
    return apiClient.post<FixingRunResult>(
      `/api/v1/commodity-fixing/${clientId}/run`,
      targetDate ? { targetDate } : {}
    );
  }
}

export const commodityFixingService = new CommodityFixingService();
